
import Vue, { PropType } from 'vue'
import { Secondhand } from '@/models'

export default Vue.extend({
  name: 'SecondhandListItem',

  props: {
    secondhand: Object as PropType<Secondhand>
  }
})
